<template>
  <div class="flight-box-title">
    <span
      v-if="primary && type === 'departure'"
      data-i18n="charterDeparture"
    >{{ $t('charterDeparture') }}</span>
    <span
      v-if="primary && type === 'arrival'"
      data-i18n="charterArrival"
    >{{ $t('charterArrival') }}</span>
  </div>
</template>

<script>
export default defineNuxtComponent({
  name: 'FlightBoxTitle',
  props: {
    primary: {
      type: Boolean,
      default: false,
    },

    type: {
      type: String,
      default: null,
    },
  },
})
</script>

<style lang="scss" scoped>
@import "@layers/web/assets/scss/modules/charter/_flight-box";
</style>
